// extracted by mini-css-extract-plugin
export default {"PollButtons":"styles_PollButtons__0aN74","textButton":"styles_textButton__IHxvx"};